module.exports = __webpack_public_path__ + "img/OY.0d162ea1.png";